/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

export const styles:any[] = ['#obpa-grid[_ngcontent-%COMP%]     :not(thead) > tr {\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n\r\n  #obpa-grid__ .ui-iggrid-colindicator {\r\n    display: inline-block;\r\n    min-width: 34px;\r\n    height: 1px;\r\n}'];


// WEBPACK FOOTER //
// ./$$_gendir/src/app/document-hitlist/components/document-hitlist-grid.component.css.shim.ngstyle.ts